import { cx, twc } from 'react-twc';

import { twx } from '@/utils/twx';

const Input = twx.input`${cx(
  'px-4.5 min-w-0 h-14 border border-gray-6 rounded-xl focus-within:outline-none focus-within:ring-2 focus-within:ring-primary flex items-center',
  'disabled:bg-gray-7 disabled:border-gray-5 disabled:cursor-not-allowed',
  'aria-[invalid=true]:border-error aria-[invalid=true]:ring-error aria-[invalid=true]:ring-1',
  'data-[invalid]:border-error data-[invalid]:ring-error data-[invalid]:ring-1',
  'placeholder:text-gray-5',
)} `;

export const InputLabel = twc.label`text-md font-bold`;

export default Input;
